<div class="sticky-menu-component" #stickyMenu>
  <div class="custom-sticky-menu">
    @for (item of menuItems; track item) {
      @if (!item.isGetInTouchSection) {
        <div class="d-none d-md-block menu-item" [class.is-active]="item.isActive">
          <a
            class="tw-text-pl-orange-300 tw-no-underline"
            [ngClass]="{ 'tw-text-pl-orange-500': item.isActive }"
            (click)="onMenuItemClicked(item)"
          >
            @if (item.displayPotentialifeIcon) {
              <pot-icon-potentialife></pot-icon-potentialife>
            } @else {
              <p>{{ item.label }}</p>
            }
          </a>
        </div>
      }
    }

    <div
      class="mobile-menu d-md-none"
      ngbDropdown
      (openChange)="onMenuToggle($event)"
      container="body"
      dropdownClass="container-dropdown-sticky-menu"
    >
      <div
        class="main-mobile-menu-item custom-sticky-menu-wrapper tw-relative tw-flex tw-items-center tw-justify-center tw-pl-10 tw-pr-2"
        ngbDropdownToggle
      >
        <div class="tw-absolute tw-left-2 tw-flex tw-h-full tw-items-center">
          <pl-burger-menu-button [isMenuOpen]="isMenuOpen()" class="" />
        </div>

        @for (item of menuItems; track item) {
          @if (item.isActive) {
            @if (item.displayPotentialifeIcon) {
              <pot-icon-potentialife class="tw-h-full tw-py-1" />
            } @else {
              <h3>{{ item.label }}</h3>
            }
          }
        }
      </div>
      <div ngbDropdownMenu>
        @for (item of menuItems; track item) {
          @if (!item.isGetInTouchSection) {
            <a
              class="menu-item-mobile tw-text-pl-orange-300 tw-no-underline"
              [ngClass]="{ 'tw-text-pl-orange-500': item.isActive }"
              (click)="onMenuItemClicked(item)"
              ngbDropdownItem
            >
              <h4 class="tw-text-pl-orange-300 tw-no-underline" [ngClass]="{ 'tw-text-pl-orange-500': item.isActive }">
                {{ item.label }}
              </h4>
            </a>
          }
        }
      </div>
    </div>
  </div>
</div>
